<template>
  <div  v-if="userInfo" class="my-info-area">
    <p class="password-check-notice">계정 보호를 위해 본인 인증이 필요합니다<br>회원정보 수정을 위해 비밀번호를 다시 한번 확인해 주세요.</p>
    <ul>
      <li>
        <div class="c-form-field">
          <label class="c-input-label-group">
            <input type="text" 
              :value="userInfo.custCd" 
              disabled 
              class="input-id-disabled" 
              title="아이디">
            <span class="input-label">아이디</span>
            <button type="button" class="c-btn-icon btn-small-delete">
              <span class="c-icon icon-small-x"></span>
            </button>
          </label>
        </div>
      </li>
      <li>


        <div>
          <!-- code -->
          <div class="c-form-field">
            <label class="c-input-label-group type-password">
                 <input
                v-if="passwordMaskingYn"
                type="password"
                required
                title="비밀번호"
                v-model="data.check" 
                @keypress.enter="checkPwdUserInfo"
                @keyup="() => (passwordTouched = true)"
                @blur="() => (passwordTouched = true)"
              />
              <input
                v-if="!passwordMaskingYn"
                type="text"
                required
                title="비밀번호"
                v-model="data.check" 
                @keypress.enter="checkPwdUserInfo"
                @keyup="() => (passwordTouched = true)"
                @blur="() => (passwordTouched = true)"
              />
              <span class="input-label">비밀번호 확인</span>
              <!-- <span class="input-helper">띄어쓰기 없는 영문, 숫자, 특수문자 (!@#$%^*+=-) 포함 8~15자</span> -->
              <!-- D: 마스킹 클릭시 is-active 추가 -->
                    <button
                      type="button"
                      class="c-btn-icon btn-eye"
                      :class="{ 'is-active': !passwordMaskingYn }"
                      @click.prevent="
                        () => (passwordMaskingYn = !passwordMaskingYn)
                      "
                    >
                      <i class="c-icon icon-eye"></i>
                    </button>
              <button type="button" class="c-btn-icon btn-small-delete"  @click="checkPwdUserRemove">
                <span class="c-icon icon-small-x"></span>
              </button>
            </label>
          </div>
          <!-- // code -->
        </div>
      </li>
    </ul>
    <!-- D: PC 전용 -->
    <div class="c-btn-area type-full only-pc">
      <button type="button" class="c-button type-primary" @click="checkPwdUserInfo"
                    :disabled="Utils.isBlank(data.check)">
        <span>확인</span>
      </button>
    </div>
    <!-- // D: PC 전용 -->
    <!-- D: MO 전용 -->
    <div class="c-btn-area type-full is-fixed only-mo" data-bottom-fixed>
      <button type="button" class="c-mo-button type-primary type-medium"  @click="checkPwdUserInfo"
                    :disabled="Utils.isBlank(data.check)">
        <span class="bold">확인</span>
      </button>
    </div>
    <!-- // D: MO 전용 -->
  </div>
</template>
<script setup name="confirmPwdMngTab">
import { api } from "@/plugins/api";
import { inject, onBeforeUnmount, onMounted, ref , defineEmits, reactive} from "vue";
import * as cmUtil from "@/utils/cmUtil.js";
import Utils from "@/js/utils";
const { isMobile } = cmUtil.useDeviceType();

const userInfo = ref(null);
const url = inject("url_prefix");

const emit = defineEmits(['check']);
const data = reactive({
  check : ''
});

//const pageData = ref(null);
//const list = ref([]);
//const mobileList = ref([]);
const scrollSensed = ref(false); // 스크롤 중복 감지를 막기 위한 변수입니다.
const passwordMaskingYn = ref(true);


onMounted(() => {
  //setYear();
  //loadSearchData();
  loadAgencyUserInfo();
  window.addEventListener("scroll", onScrollEvent, true);
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", onScrollEvent);
});


const loadAgencyUserInfo = async () => {
  const res = await api.get(`${url}/agency/user/my-info`);
  userInfo.value = res.data;
};


const checkPwdUserInfo = async () => {
  const res =  await  api.post(`${url}/utility/userinfo/selectConfirmPwd`, {
    check:data.check,
  })
  //alert( res.data);
  //emits('checkMem', res.data);
  emit('check', { check : res.data, message : res.message })
};

// const checkPwdUserInfo = await api.post(`${url}/utility/userinfo/selectConfirmPwd`, {
//   ...searchParams.value,
// });

const checkPwdUserRemove = () => {
  data.check = '';
}


const onScrollEvent = () => {
  if (scrollSensed.value) return;
  if (!isMobile.value) return;

  const scrollTop = Math.ceil(document.documentElement.scrollTop);
  const scrollHeight = document.documentElement.scrollHeight;
  const clientHeight = document.documentElement.clientHeight;

  const isBottom = scrollTop + clientHeight >= scrollHeight ? true : false;

  if (isBottom) {
    scrollSensed.value = true;
    setTimeout(() => {
      scrollSensed.value = false;
    }, 50);
  }
};

</script>
<style scoped></style>